// extracted by mini-css-extract-plugin
export var addressFields = "_gs-0";
export var animationContainer = "_gs-1";
export var footer = "_gs-2";
export var lineItems = "_gs-3";
export var modalContent = "_gs-4";
export var orderName = "_gs-5";
export var strong = "_gs-6";
export var warning = "_gs-7";